import { render, staticRenderFns } from "./lightbox-awareness.vue?vue&type=template&id=4a26a127&scoped=true&"
import script from "./lightbox-awareness.vue?vue&type=script&lang=js&"
export * from "./lightbox-awareness.vue?vue&type=script&lang=js&"
import style0 from "./lightbox-awareness.vue?vue&type=style&index=0&id=4a26a127&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a26a127",
  null
  
)

export default component.exports